<mc-editor-toolbar [toolbarControl]="toolbarControl$ | async" (itemClick)="onItemClicked($event)" (dropdownMenuClosed)="onDropdownMenuClosed($event)">
  <ng-template mcEditorToolbarItem="lang" let-item>
    <i *ngIf="showLang">{{ lang }}</i>
  </ng-template>
</mc-editor-toolbar>